import { required, Validator } from '@/entities/validation';
import { EntityTypePropertyForm } from './model';

export const validate: Validator<EntityTypePropertyForm> = record => [
  ...required(record.label, 'label'),
  ...required(record.dataType, 'dataType'),
  ...(record.dataType === 'dropdown' && !record.optionSetId
    ? required('', 'optionSetId')
    : []),
];
